export default {
    'Home': 'Home',
    'Need_Funds_To ': 'Need funds to',
    'We_Can_Chang_Many_Lives': 'WE CAN CHANGE MANY LIVES',
    'Home_Message': 'Please come forward and contribute. Your contribution will transform lives. Provide direct support to an individual, family or community by paying medical expenses or offering financial aid.',
    'Hello_User': 'Hello {user}',
    'Donate_Now': 'Donate Now!',
    'Spend_Monthly': 'Spent Monthly',
    'Top_Donation': 'Top Donation',
    'Recent_Donation': 'Recent Donation',
    'Monthly_Organizations_Spend': 'Monthly Organizations Spent',
    'Monthly_Project_Spend': 'Monthly Project Spent',
    'View_All': 'View All Donations',
    'Running_Projects': 'Running Projects',
    'Total_Received:': 'Total Received',
    'Total_Spend': 'Total Spent',
    'Contribute_Now': 'Contribute Now',
    'View_More': 'View More',
    'In_Queue_Projects': 'In queue Projects',
    'Completed_Projects': 'Completed Projects',
    'Supporting_A_Good_Cause': 'SUPPORTING A GOOD CAUSE',
    'Good_Cause': 'Find a Good Cause Find a cause you care about and start fundraising today than No one has ever become poor by giving',
    'How_It_Works': 'How It Works',
    'How_It_Work_Sub_Title': "We've helped raise funds for a variety of causes.",
    'Start_Campaigns': 'Start Campaigns',
    'Collect_Funds': 'Collect funds',
    'Help_People': 'Help people',
    'How_Info_1': 'Quis autem velum iure reprehe nderit. Lore m ipsum dolor sit amet, consectetur. Lorem ipsum dolor sit amet ctetur',
    'How_Info_2': 'Quis autem velum iure reprehe nderit. Lore m ipsum dolor sit amet, consectetur. Lorem ipsum dolor sit amet ctetur',
    'How_Info_3': 'Quis autem velum iure reprehe nderit. Lore m ipsum dolor sit amet, consectetur. Lorem ipsum dolor sit amet ctetur',
    'About_Charity_Organizations': 'About Charity Organizations',
    'About_Org_Info': 'Be it for a personal need, social cause or a creative idea - you can count on us colleagues and potential well-wishers.',
    'Thank_You_For_Supporting_Us': 'Thank you for supporting us',
    'Footer_Info': ' Our mission is to build one of the largest networks of innovative schools that empowers children to maximize their potential and that influences systemic reform',
    'Copy_Write_Info': 'Charity Organizations',
    'Terms_Of_Use': 'Terms of Use',
    'Privacy_Policy': 'Privacy Policy',
    'Support': 'Support',
    'Share': 'Share',
    'Projects': 'Projects',
    'Organisation': 'Organisation',
    'Fundraise_For': 'Fundraise for',
    'Charity_Donators': 'Charity Donators',
    'Home': 'Home',
    'Total_Projects': 'Total Projects',
    'Received_Amount': 'Received Amount',
    'Task_Force': 'Task Force for Global Health',
    'Donate_Help': 'DONATE & HELP African Children For Education',
    'Office': 'Office #429, Amanora Chambers, Hadapsar, Pune, Maharashtra',
    'Email': 'Email: info@enovate-it.com',
    'Charity_Trust': 'Charity Trust, since 1988, has been working towards helping children to meet their dreams. We as an organization believe that children shouldn’t be denied their rights.',
    'Poblems_Of_Poverty': 'The problems of poverty, illiteracy and homelessness seem to fall hardest on the children of migratory families, these families struggle to find basic child care and nutrition let alone guarantee an education for their children. In our experience, most parents tend to become helpless and hopeless while others settle for very mean options, some parents even turn violent and abusive; leaving these children in spaces they don’t feel safe.',
    'All_Projects': 'All Projects',
    'Total_Contribution_Amount': 'Total Contribution Amount',
    'Donation_Now': 'Donate Now',
    'Project_Activities': 'Project Activities',
    'Spent_Amount': 'Spent Amount:',
    'Bank_Details': 'Bank Details',
    'Bank_Name': 'Bank Name',
    'Beneficiary_Name': 'Beneficiary Name',
    'BeneficiaryIBAN': 'Beneficiary Account (IBAN)',
    'Swift_BIC_Code': 'SWIFT/BIC Code',
    'Organisation_Name': 'Organisation Name',
    'Payment_Ref': 'Payment Ref. Number',
    'Ok': 'Ok',
    'Next': 'Next',
    'User_Information': 'User Information',
    'Your_Name': 'Your Name',
    'Donation_Amount': 'Donation Amount',
    'Email_Id': 'Email Id',
    'Make_anonymous': 'Make my donation anonymous',
    'Back': 'Back',
    'Submit': 'Submit',
    'Thank_You': 'Thank You!',
    'Finish': 'Finish',
    'Thank_You_info_1': 'THANK YOU for making a donation!',
    'Thank_You_info_2': 'Your gift is sure to make a real difference to the people\'s lives.',
    'Thank_You_info_3': 'An acknowledgement email with the details of your donation will be sent to the email addres you provided.',
    'Help_sharing': 'Help by sharing',
    'Copy': 'Copy',
    'Close': 'Close',
    'Search_Donator': 'Search donator with name, project name, pay amount and Payment Ref id ...',
    'Search_Projects': 'Search Projects...',
    'Project_name': 'Project Name',
    'Running_Projects': 'All Running Projects',
    'In_queue_Projects': 'All In queue Projects',
    'Completed_Projects': ' All Completed Projects',
    'No_Projects_Available':'No Projects Available!',
    'Completed_Projects':' All Completed Projects',
    'Payee_Name':'Payee Name',
    'Amount':'Amount',

    'Reference_Id':'Reference Id',
    'Donation_Amount':'Donation Amount',
    'Donation_Date':'Donation Date',
    'User_Name':'User Name',
    'Org_Proj':'Organzation/Project'

} 
